import { addToBasket } from '~/common';
import $ from '~/qwery';
import bean from '~/bean';
import Button from '~/components/button';
import BasketButton from '~/components/basket-button';
import RadioGroup from '~/components/radio-group';
import Form from '~/components/form';
import BasketPopup from '~/components/popup/basket-popup';
import PhotoPopup from '~/components/popup/photo-popup';

if (document.querySelector('.b-page.product-page')) {
    const $productPage = $('.b-page.product-page');
    const $orderForm = $('.order-form', $productPage);
    const $sizesRadioGroup = $('.sizes-radio-group', $productPage);
    const $orderButton = $('.order-button', $productPage);
    const $photos = $('.photos', $productPage);

    const basketButton = new BasketButton('.b-basket-button');
    $('img', $photos).each(img => {
        new Button(img);
    });
    const orderForm = new Form($orderForm);
    const sizesRadioGroup = $sizesRadioGroup[0] ?
        new RadioGroup($sizesRadioGroup)
    : null;
    let orderButton;
    if ($orderButton.length) {
        orderButton = new Button($orderButton);
    }

    let photoPopup;
    bean.on($photos[0], 'press', 'img', e => {
        const $target = $(e.target);
        if (photoPopup)
            return;
        photoPopup = new PhotoPopup(
            $('h1', $productPage).text(),
            $photos.data('product-name'),
            JSON.parse($photos.data('photos')),
            $target.data('i'), {
                onDestroy: () => {
                    photoPopup = null;
                    $target[0].focus();
                },
            })
    });

    if ($orderButton.length)
        bean.on($orderButton[0], 'press', () => {
            if (orderButton.disabled())
                return;
            if ( ! orderForm.validate())
                return;
            orderButton.disabled(true);
            addToBasket(
                $productPage.data('id'),
                sizesRadioGroup ? sizesRadioGroup.value() : null)
            .then(resp => {
                const basketButtonButton = new Button(basketButton.$el);
                let nItems = resp.data.items.length;
                basketButton.update(nItems);
                basketButtonButton.disabled( ! nItems);
                const popup = new BasketPopup(resp.data, {
                    onChange: data => {
                        nItems = data.items.length;
                        basketButton.update(nItems);
                        basketButtonButton.disabled( ! nItems);
                        if ( ! nItems)
                            popup.destroy();
                    },
                    onDestroy: () => {
                        orderButton.disabled(false);
                        $orderButton[0].focus();
                    },
                });
            });
        });
}



// WEBPACK FOOTER //
// ./makosh/assets/pages/product.js